<script setup lang="ts">
import { Card } from "@/components/Ui";

const { t } = useI18n();
</script>
<template>
  <Card
    :title-class="`${$style[`root-title`]} ${
      $style[`root-title-${$i18n.locale}`]
    }`"
    :wrapper-class="$style[`root-wrapper`]"
    :class="`${$style[`root`]}`"
  >
    <template #title>
      {{ t("block.whitelabelInstantCards.title_1") }} <br />
      {{ t("block.whitelabelInstantCards.title_2") }} <br />
      {{ t("block.whitelabelInstantCards.title_3") }}
    </template>
  </Card>
</template>

<style lang="scss" module>
.root {
  @apply bg-neutral-900 flex items-center;

  &-wrapper {
    @apply w-full max-w-[462px] text-white relative z-10;
  }

  &-title {
    @apply text-[32px] xxs:text-[40px] xs:text-[42px] md:text-[42px] lg:text-[52px] xl:text-[56px];
    &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
    &-be,
    &-bg,
    &-de,
    &-it,
    &-pt,
    &-tr,
    &-ua,
    &-zh,
    &-es,
    &-fr,
    &-ja,
    &-ru,
    &-th,
    &-hi,
    &-ar,
    &-bn,
    &-ko,
    &-vi,
    &-sw,
    &-zh {
      @apply text-[32px] xxs:text-[40px] xs:text-[42px] md:text-[42px] lg:text-[52px] xl:text-[56px];
    }
    &-pl {
      @apply text-[28px] xxs:text-[34px] xs:text-[40px] md:text-[36px] lg:text-[50px] xl:text-[56px];
    }
  }
}
</style>
